const productPhase = "Product Phase";
const constructionPhase = "Construction Phase";
const usePhase = "Use Phase";
const endOfLifePhase = "End-of-life Phase";
const benefitsPhase = "Benefits Phase";

export const lca_phases = [productPhase, constructionPhase, usePhase, endOfLifePhase, benefitsPhase];

const A1_A3 = "A1_A3";
const A4_A5 = "A4_A5";
const B = "B";
const C = "C";
const D = "D";

export const lca_phase_map = { [productPhase]: A1_A3, [constructionPhase]: A4_A5, [usePhase]: B, [endOfLifePhase]: C, [benefitsPhase]: D };
export const lca_phase_map_reverse = { [A1_A3]: productPhase, [A4_A5]: constructionPhase, [B]: usePhase, [C]: endOfLifePhase, [D]: benefitsPhase };
